<!-- 项目文件 -->
<template>
    <div>
        <Header :Logo="logo" :city="cityName" :Link="link" :TitleList="titleList" :Color="color" :img="bgImg"></Header>
        <div class="w100p pt40 pb40">
            <div class="w1200 mauto">
                <div class="textc mt20 mb20">
                    <p class="fs36 c333 disinblock posre">
                        <span class="border-bottom1">
                            学车视频
                        </span>
                    </p>
                </div>
                <div class="w100p overhidden">
                    <div class="textc border2 pt16 pb16">
                        <span class="fs20 c666 ml48 mr48  cursor" @click="activeIndex(0)"
                            :class="{'active':index1==0}">科目二</span>
                        <span class="fs20 c666 ml48 mr48 cursor" @click="activeIndex(1)"
                            :class="{'active':index1==1}">科目三</span>
                    </div>
                    <div>
                        <div class="w100p mt20" v-if="index1 == 0">
                            <ul class="w100p disinblock ml-10">
                                <li :class="{'bgcolor1':current_index==index}"
                                    class="box pl20 w25p floatl disinblock posre" v-for="(item,index) in videolist"
                                    :key="index" >
                                    <p class="posab bottom10   w78p over_1 textindent cfff fs14 zindex999">
                                        {{ item.title }}
                                    </p>
                                    <video-player class="video-player vjs-custom-skin" ref="videoPlayer"
                                        :playsinline="true" :options="playerOptions[index]"
                                        @play="onPlayerPlay($event,index)" >
                                    </video-player>
                                </li>
                            </ul>
                        </div>

                        <div class="w100p  mt20 " v-if="index1 == 1">
                            <ul class="w100p disinblock ml-10">
                                <li :class="{'bgcolor1':current_index==index}"
                                    
                                    class="box pl20 w25p floatl disinblock posre" v-for="(item,index) in videoList33"
                                    :key="index" v-if="item.istwo==0">
                                    <p class="posab bottom10   w78p over_1 textindent cfff fs14 zindex999">
                                        {{ item.title }}
                                    </p>
                                    <video-player class="video-player vjs-custom-skin"
                                        :playsinline="true" :options="playerOptions33[index]"
                                        @play="onPlayerPlay33($event,index)" ref="videoPlayer33">
                                    </video-player>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <Footer></Footer>
    </div>
</template>

<script>
    import {
        videoPlayer
    } from 'vue-video-player'
    import 'video.js/dist/video-js.css'
    import Header from '@/components/Header'
    import Footer from '@/components/Footer'
    export default {
        data() {
            return {
                color: 1,
                link: 2,
                titleList: 4,
                logo: 'home',
                bgImg: require('../../public/img/img51.png'),
                index1: 0,
                current_index: -1,
                cityName: '',
                videolist: [{
                    istwo: 1,
                    title: "综合教学视频", //科目二
                    posterImg: 'https://image.yixueyijia.com/xconline/upload/images/article/spsy/1545898480861.png',
                    movie: "https://image.yixueyijia.com/xconline/upload/images/article/sp/1545898480861.mp4"
                }, {
                    istwo: 1,
                    title: "起步时车辆后溜距离小于30cm的",
                    posterImg: 'https://image.yixueyijia.com/xconline/upload/images/article/spsy/1508896705490.jpg',
                    movie: "https://image.yixueyijia.com/xconline/upload/images/article/sp/1488178134643.mp4"
                }, {
                    istwo: 1,
                    title: "操纵转向盘手法不合理的",
                    posterImg: 'https://image.yixueyijia.com/xconline/upload/images/article/spsy/1508896667614.jpg',
                    movie: "https://image.yixueyijia.com/xconline/upload/images/article/sp/1488178604359.mp4"
                }, {
                    istwo: 1,
                    title: "起步或行驶中挂错挡，不能及时纠正的",
                    posterImg: 'https://image.yixueyijia.com/xconline/upload/images/article/spsy/1508896650826.jpg',
                    movie: "https://image.yixueyijia.com/xconline/upload/images/article/sp/1488178769700.mp4"
                }, ],
                //科目三
                videoList33: [{
                    istwo: 0,
                    id: 0,
                    title: "不合格情形 不按规定使用安全带或者安全头盔的",
                    posterImg: 'https://image.yixueyijia.com/xconline/upload/images/article/spsy/1508896060999.jpg',
                    movie: "https://image.yixueyijia.com/xconline/upload/images/article/sp/1488347995344.mp4"
                }, {
                    istwo: 0,
                    id: 1,
                    title: "不合格情形 道路驾驶技能考试评判标准分通用评判标准和专项评判标准",
                    posterImg: 'https://image.yixueyijia.com/xconline/upload/images/article/spsy/1508896047509.jpg',
                    movie: "https://image.yixueyijia.com/xconline/upload/images/article/sp/1488348128472.mp4"
                }, {
                    istwo: 0,
                    id: 2,
                    title: "不合格情形 遮挡、关闭车内音视频监控设备的",
                    posterImg: 'https://image.yixueyijia.com/xconline/upload/images/article/spsy/1508896031836.jpg',
                    movie: "https://image.yixueyijia.com/xconline/upload/images/article/sp/1488348500642.mp4"
                }, {
                    istwo: 0,
                    id: 3,
                    title: "不合格情形 不按考试员指令驾驶的",
                    posterImg: 'https://image.yixueyijia.com/xconline/upload/images/article/spsy/1508896009443.jpg',
                    movie: "https://image.yixueyijia.com/xconline/upload/images/article/sp/1488348711114.mp4"
                }, ],
                playsinline: true,
                playerOptions: [],
                playerOptions33: [],
                options: ""
            };
        },
        components: {
            Header,
            Footer,
            videoPlayer
        },
        methods: {
            activeIndex(id) {
                this.index1 = id;
            },
            getMovieList() {
                let that = this;

                // 这里正常来说应该是从后台获取的数据，以下操作都是在成功的回调函数里
                for (var i = 0; i < that.videolist.length; i++) {
                    for (var i = 0; i < that.videolist.length; i++) {
                        let arrs = {
                            playbackRates: [1.0, 2.0, 3.0], //播放速度
                            autoplay: false, //如果true,浏览器准备好时开始回放。
                            muted: false, // 默认情况下将会消除任何音频。
                            loop: false, // 导致视频一结束就重新开始。
                            preload: "auto", // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
                            language: "zh-CN",
                            aspectRatio: "16:9", // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
                            fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
                            sources: [{
                                type: "video/mp4",
                                type: "video/ogg",
                                src: that.videolist[i].movie //url地址
                            }],
                            poster: that.videolist[i].posterImg, //封面地址
                            notSupportedMessage: "此视频暂无法播放，请稍后再试", //允许覆盖Video.js无法播放媒体源时显示的默认信息。
                            controlBar: {
                                timeDivider: true,
                                durationDisplay: true,
                                remainingTimeDisplay: false,
                                fullscreenToggle: true //全屏按钮
                            }
                        };
                        that.playerOptions.push(arrs);
                    }
                }
            },
            getMovieList33() {
                let that = this;
                // 这里正常来说应该是从后台获取的数据，以下操作都是在成功的回调函数里
                for (var i = 0; i < that.videoList33.length; i++) {
                    for (var i = 0; i < that.videoList33.length; i++) {
                        let arrs = {
                            playbackRates: [1.0, 2.0, 3.0], //播放速度
                            autoplay: false, //如果true,浏览器准备好时开始回放。
                            muted: false, // 默认情况下将会消除任何音频。
                            loop: false, // 导致视频一结束就重新开始。
                            preload: "auto", // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
                            language: "zh-CN",
                            aspectRatio: "16:9", // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
                            fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
                            sources: [{
                                type: "video/mp4",
                                type: "video/ogg",
                                src: that.videoList33[i].movie //url地址
                            }],
                            poster: that.videoList33[i].posterImg, //封面地址
                            notSupportedMessage: "此视频暂无法播放，请稍后再试", //允许覆盖Video.js无法播放媒体源时显示的默认信息。
                            controlBar: {
                                timeDivider: true,
                                durationDisplay: true,
                                remainingTimeDisplay: false,
                                fullscreenToggle: true //全屏按钮
                            }
                        };
                        that.playerOptions33.push(arrs);
                    }
                }
            },
            onPlayerPlay(player, index) {
                this.current_index = index
                let that = this.$refs.videoPlayer;
                for (let i = 0; i < that.length; i++) {
                    if (i != index)
                        that[i].player.pause()
                }

            },
            onPlayerPlay33(player, index) {
                this.current_index = index
                let that = this.$refs.videoPlayer33;
                for (let i = 0; i < that.length; i++) {
                    if (i != index)
                        that[i].player.pause()
                }
            },

        },
        created() {
            this.getMovieList();
            this.getMovieList33();
            this.cityName = this.$store.state.cityName;
        },
        mounted() {

        },
    }
</script>
<style scoped>
    .bgcolor1 p {
        display: none;
    }
</style>